export default {
	methods: {
		$deleteFromArray(arr, toDelete) {
			const set = new Set(arr)

			if (Array.isArray(toDelete)) {
				toDelete.forEach(it => set.delete(it))
			} else {
				set.delete(toDelete)
			}

			return [ ...set ]
		}
	}
}